import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import "./TestInfoPage.css";
import { toast } from 'react-toastify';
import { api } from "../../config";
const TestInfoPage = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [quizData, setQuizData] = useState(null);
  const [rules, setRules] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const formData = location.state?.formData;

  console.log("Received Candidate Data:", formData);

  useEffect(() => {
    const fetchQuizAndCategories = async () => {
      try {
        const quizDataFromStorage = JSON.parse(localStorage.getItem("selectedQuiz"));
        if (!quizDataFromStorage) {
          setError("No quiz data found in localStorage");
          setLoading(false);
          return;
        }

        const quizId = quizDataFromStorage.id;
        console.log("Fetching quiz data for ID:", quizId);

        const quizResponse = await axios.get(`${api.API_URL}api/quizeData/${quizId}`);
        const quiz = quizResponse.data;

        let rawCategories = [];
        try {
          rawCategories =
            typeof quiz.category_data === "string"
              ? JSON.parse(quiz.category_data)
              : quiz.category_data;
        } catch (err) {
          console.error("Invalid category_data format", err);
        }

        const categoryResponse = await axios.get(`${api.API_URL}api/categories`);
        const allCategories = categoryResponse.data;

        const categories = rawCategories.map((cat) => {
          const matched = allCategories.find((c) => c.id === cat.category_id);
          return {
            name: matched ? matched.name : "Unknown Category",
            questions: cat.num_questions || 0,
            minCorrect: cat.min_correct || 0,
          };
        });

        const settingsResponse = await axios.get(`${api.API_URL}api/get/setting`);
        console.log("Raw settings response:", settingsResponse.data);

        // Try to dig through any nesting
        let settingsData =
          settingsResponse.data?.data?.data ||
          settingsResponse.data?.data ||
          settingsResponse.data;

        // Show what we ended up with
        console.log("Resolved settingsData:", settingsData);

        let allRules = [];

        if (Array.isArray(settingsData)) {
          allRules = settingsData
            .map(item => item.rules)
            .filter(rule => typeof rule === "string" && rule.trim() !== "");
        } else if (settingsData && typeof settingsData === "object" && settingsData.rules) {
          if (typeof settingsData.rules === "string" && settingsData.rules.trim() !== "") {
            allRules = [settingsData.rules];
          }
        }

        console.log("Final Fetched Rules:", allRules);


        const transformedData = {
          title: quiz.name,
          description: quiz.description,
          duration: quiz.time_limit,
          categories: categories,
          minCorrect: quiz.min_correct || 0,
        };

        setQuizData(transformedData);
        setRules(allRules);
        setLoading(false);
        console.log("Final Quiz Data with Categories:", transformedData);
      } catch (err) {
        console.error("Error fetching data:", err);
        setError("Error fetching quiz or categories data");
        setLoading(false);
      }
    };

    fetchQuizAndCategories();
  }, []);

  const handleNavigate = async () => {
    try {
      const quizDataFromStorage = JSON.parse(localStorage.getItem("selectedQuiz"));
      if (!quizDataFromStorage || !quizDataFromStorage.id) {
        console.error("Quiz ID not found in localStorage");
        return;
      }
      navigate("/candidate-form/test-tack", { state: { formData } });
    } catch (error) {
      console.error("Failed to start or generate the quiz:", error);
      toast.error("An error occurred. Please try again.");
    }
  };

  const { title, description, duration, categories, minCorrect } = quizData || {};
  const totalQuestions = categories?.reduce((sum, cat) => sum + cat.questions, 0);

  return (
    <div className="test-info d-flex flex-column align-items-center min-vh-100 p-2 p-md-4">
      <div className="card w-100 max-w-3xl p-2 p-md-4 rounded-lg shadow-sm border">
        {loading ? (
          <p className="text-center text-muted">Loading test details...</p>
        ) : error ? (
          <p className="text-center text-danger">{error}</p>
        ) : (
          <>
            <h1 className="text-white bg-danger p-2 p-md-3 rounded mb-2 text-center fs-4 fs-md-3">{title}</h1>
            <p className="text-dark text-center small small-md">{description}</p>

            <div className="d-flex flex-column flex-md-row justify-content-between align-items-center bg-dark text-white p-2 p-md-3 rounded">
              <span className="fw-semibold mb-2 mb-md-0 small small-md">
                🕒 Duration: {duration} minutes
              </span>
              <span className="fw-semibold small small-md">
                📌 Total Questions: {totalQuestions}
              </span>
            </div>

            <h2 className="fs-5 fs-md-4 fw-semibold text-dark mt-3 mt-md-4">  📌 Category-wise Question Summary (with Minimum Passing Criteria)</h2>
            <ul className="mt-2 list-unstyled">
              {categories.map((cat, index) => (
                <li key={index} className="text-dark small small-md">
                  <span className="fw-bold text-danger">{cat.name}:</span>{" "}
                  {cat.questions} questions (Min Correct: {cat.minCorrect})
                </li>
              ))}
            </ul>

            <h2 className="fs-5 fs-md-4 fw-semibold text-dark mt-3 mt-md-4 text-center">📜 Rules & Guidelines</h2>
            <ul className="list-unstyled ms-2 ms-md-4 mt-2 text-dark">
              {rules.length > 0 ? (
                rules.map((rule, index) => (
                  <li
                    key={index}
                    className="rule-item mb-2 mb-md-3 p-2 p-md-3 border-start border-1 rounded shadow-sm d-flex align-items-start gap-2 gap-md-3"
                    style={{ backgroundColor: "white" }}
                  >
                    <span
                      className={`badge rounded-pill text-danger px-2 px-md-3 py-1 py-md-2 fs-6`}
                      style={{ minWidth: "30px", textAlign: "center" }}
                    >
                      {index + 1}
                    </span>
                    <span className="text-dark small small-md" style={{ fontWeight: "500" }}>
                      {rule}
                    </span>
                  </li>
                ))
              ) : (
                <li className="text-muted text-center small">No rules available</li>
              )}
            </ul>

            {/* <h2 className="fs-5 fs-md-4 fw-semibold text-dark mt-3 mt-md-4">🎨 Question Status Guide</h2>
            <div className="row row-cols-2 row-cols-md-4 g-2 g-md-4 mt-2 mt-md-3">
              <div className="col d-flex flex-column align-items-center">
                <div
                  className="d-flex justify-content-center align-items-center bg-light border rounded-circle"
                  style={{ width: "40px", height: "40px", fontSize: "16px" }}
                >
                  1
                </div>
                <p className="text-dark mt-1 small">Unattempted</p>
              </div>
              <div className="col d-flex flex-column align-items-center">
                <div
                  className="d-flex justify-content-center align-items-center bg-success text-white rounded-circle"
                  style={{ width: "40px", height: "40px", fontSize: "16px" }}
                >
                  2
                </div>
                <p className="text-dark mt-1 small">Answered</p>
              </div>
              <div className="col d-flex flex-column align-items-center">
                <div
                  className="d-flex justify-content-center align-items-center bg-danger text-white rounded-circle"
                  style={{ width: "40px", height: "40px", fontSize: "16px" }}
                >
                  3
                </div>
                <p className="text-dark mt-1 small">Skipped</p>
              </div>
              <div className="col d-flex flex-column align-items-center">
                <div
                  className="d-flex justify-content-center align-items-center bg-warning text-white rounded-circle"
                  style={{ width: "40px", height: "40px", fontSize: "16px" }}
                >
                  4
                </div>
                <p className="text-dark mt-1 small">Marked for Review</p>
              </div>
            </div> */}

            <button
              onClick={handleNavigate}
              className="btn btn-danger w-100 mt-3 mt-md-4 py-2 fs-6 fs-md-5 fw-semibold text-uppercase"
            >
              🚀 Start Test
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default TestInfoPage;
